export default "__VITE_ASSET__f65f0cd5__"